/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminPalletOrderList,
    AdminPalletOrderListFromJSON,
    AdminPalletOrderListFromJSONTyped,
    AdminPalletOrderListToJSON,
} from './AdminPalletOrderList';

/**
 * 
 * @export
 * @interface AdminAllPalletOrdersResponse
 */
export interface AdminAllPalletOrdersResponse {
    /**
     * 
     * @type {Array<AdminPalletOrderList>}
     * @memberof AdminAllPalletOrdersResponse
     */
    items?: Array<AdminPalletOrderList>;
}

export function AdminAllPalletOrdersResponseFromJSON(json: any): AdminAllPalletOrdersResponse {
    return AdminAllPalletOrdersResponseFromJSONTyped(json, false);
}

export function AdminAllPalletOrdersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAllPalletOrdersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(AdminPalletOrderListFromJSON)),
    };
}

export function AdminAllPalletOrdersResponseToJSON(value?: AdminAllPalletOrdersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': !value.items ? undefined : ((value.items as Array<any>).map(AdminPalletOrderListToJSON)),
    };
}

